const CoustomUrls = {
  signIn: `${process.env.REACT_APP_VOUCHERS_URL}/api/user/login`,
  registerPassword: `${process.env.REACT_APP_VOUCHERS_URL}/api/user/RegisterPassword`,
  medicine:{
    types:`${process.env.REACT_APP_API_INVINTORY_MICRO_SERVICE}/DiseaseType`,
  categories:`${process.env.REACT_APP_API_INVINTORY_MICRO_SERVICE}/category`
},
  getAllUnits: `${process.env.REACT_APP_OFFERS_URL}/Attribute/GetAllUnits`,
  getUnitDetails: `${process.env.REACT_APP_OFFERS_URL}/Attribute/GetUnitDetails`,
  getUnitsPerCountry: `${process.env.REACT_APP_OFFERS_URL}/Attribute/GetUnitsPerCountry`,
  addEditUnit: `${process.env.REACT_APP_OFFERS_URL}/Attribute/AddUnit`,
  getAllServices: `${process.env.REACT_APP_OFFERS_URL}/portal/GetAllServicesByLevel`,
  getServiceDetails: `${process.env.REACT_APP_OFFERS_URL}/portal/GetServiceDetails`,
  addService: `${process.env.REACT_APP_OFFERS_URL}/portal/AddServiceAcrossCountries`,
  updateService: `${process.env.REACT_APP_OFFERS_URL}/portal/updateService`,
  getCitiesByCountryId: `${process.env.REACT_APP_STATIC_URL}/api/city/GetCitiesByCountryId`,
  getAreasByCityId: `${process.env.REACT_APP_STATIC_URL}/api/Area/GetAreasByCityId`,
  postVoucher: `${process.env.REACT_APP_VOUCHERS_URL}/api/voucher/CreateCampaign`,
  getSpecialties: `${process.env.REACT_APP_VEZEETA_NATIVE_URL}/api/Specialities/GetMainSpecialities`,
  getCampaigns: `${process.env.REACT_APP_VOUCHERS_URL}/api/voucher/GetCampaigns`,
  stopCampaign: `${process.env.REACT_APP_VOUCHERS_URL}/api/voucher/StopCampaign`,
  getCountries: `${process.env.REACT_APP_STATIC_URL}/api/Country/GetCountries?isVirtual=true`,
  getProducts: `${process.env.REACT_APP_VOUCHERS_URL}/api/voucher/GetProducts`,
  subscription:{
    getCategories: `${process.env.REACT_APP_SUBSCRIPTION_URL}/api/categories`,
    getProducts: `${process.env.REACT_APP_SUBSCRIPTION_URL}/api/products`,
  },
  services: {
    medicalServices: `${process.env.REACT_APP_VOUCHERS_BASE}/medicalservices-api/api/search`,
    doctorsSearch: `${process.env.REACT_APP_VOUCHERS_BASE}/doctors-search-api/api/search`,
    branches: `${process.env.REACT_APP_VOUCHERS_BASE}/account-management-api/api/branches`
  },
  rewards: {
    campaigns: `${process.env.REACT_APP_VOUCHERS_URL}/api/rewards/campaigns`,
    campaignById: id => `${process.env.REACT_APP_VOUCHERS_URL}/api/rewards/campaigns/${id}`,
    campaignStatus: id => `${process.env.REACT_APP_VOUCHERS_URL}/api/rewards/campaigns/${id}/status`
  }
};
export default CoustomUrls;
